import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import useTeamStore from 'store/teamStore';
import Paper from 'components/system/Paper';
import useTeamMembers from 'hooks/useTeamMembers';

const CustomPaper = ({ ...props }) => (
  <Paper elevation={10} {...props} />
);

const MEMBERS_FILTERS = 'membersIds';

const JobsFilters = ({ teamId, onFilterChange, filters }) => {
  useTeamMembers(teamId);

  const members = useTeamStore((state) => state.members.list);

  const selectedOption = useMemo(
    () => members?.find(({ userId }) => userId === filters.membersIds),
    [members, filters.membersIds],
  );

  const optionAccessors = {
    options: members || [],
    getOptionLabel: (member) => member.displayName,
    getOptionValue: (member) => member.userId,
  };

  return (
    <Box sx={{ padding: '25px 0' }}>
      <Autocomplete
        {...optionAccessors}
        disablePortal
        name={MEMBERS_FILTERS}
        value={selectedOption || ''}
        inputValue={selectedOption?.displayName || ''}
        className="autocomplete"
        sx={{ width: 300 }}
        PaperComponent={CustomPaper}
        onChange={(e, option) => {
          onFilterChange(MEMBERS_FILTERS, option?.userId);
        }}
        renderInput={(params) => <TextField {...params} label="Filter by user" />}
      />
    </Box>
  );
};

export default JobsFilters;
